<template>
  <div id="top">
    <div id="logo-container">
      <div id="logo" title="Lovely Plains - Website in Progress..." />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Top',
};
</script>

<style scoped lang="scss">
@import '../scss/frame-animation.scss';

#top {
  background: url('../assets/background.png') center center;
  background-size: cover;
  height: 100vh;
  width: 100%;
  overflow: hidden;

  & > #logo-container {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    & > #logo {
      @include frame-animation('../assets/logo-animation.png', 12, 576, 296, 288, 148, 144, 74);
    }
  }
}
</style>
